import { Component, OnInit, Input, SimpleChange, ViewChild, ElementRef } from '@angular/core';
import { DataService } from '../../_services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Item } from '../../_core/_interface/item';
import { User } from '../../_core/_interface/user';
import { Subject } from 'rxjs';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { Title } from '@angular/platform-browser';
// import { MapsAPILoader } from '@agm/core';
import { VisualMapWithProjStatisticComponent } from '../visual-map-with-proj-statistic/visual-map-with-proj-statistic.component';
// import { } from '@agm/core/services/google-maps-types';
import { TranslateService } from '@ngx-translate/core';

import { fromEvent } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { MapInfoWindow } from '@angular/google-maps';


declare const google: any;

@Component({
  selector: 'app-n-map',
  templateUrl: './n-map.component.html',
  styleUrls: ['./n-map.component.scss'],
  animations: [
    trigger('slideRight', [

      state('void', style({ transform: 'translateX(-100%)', opacity: 0, right: '-100%' })),

      transition('void => *', [
        animate(2000)
      ])
    ])
  ]
})
export class NMapComponent implements OnInit {
  title = 'project';
  lat = 0;
  lng = 0;
  zoom;
  items: Item[];
  allProjects: Item[];
  public compId;
  itemToEdit: Item;
  user: User;
  marker_icon = '../assets/img/icon-small.png';
  routerUrl;
  itemToview: Item;
  itemContent = false;
  company;
  mapToggle = false;
  styles: any[];
  projSearch: boolean = false;
  compTitle: string = '';
  buildings: any[];
  compositeDesign: boolean = false;
  unika: boolean = false;
  urlSwitcher: string = '';
  @ViewChild(VisualMapWithProjStatisticComponent) visualMapChildComponent: VisualMapWithProjStatisticComponent;

  @Input() mapToggleMoreThan0: Subject<boolean>;
  pageTitle: any;
  // infoWindow: any;
  showWindow: boolean = false;
  markers: any;
  mapRef: any;
  latitude = 31.717918;
  longitude = 34.634185;
  showVisualMap: boolean = false;
  mapWidth: string = '1920'; // initialize with a default value
  mapHeight: string = '1080';
  marker_item1: any;
  // markers1: google.maps.Marker[] = [];
  //  @ViewChild('gnmapContainer', { static: false }) gmap: ElementRef;
  // map: google.maps.Map;
  markerNew;
  center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  markerOptions: google.maps.MarkerOptions = { draggable: false };
  markerPositions: google.maps.LatLngLiteral[] = [];
  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;


  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    // private mapsAPILoader: MapsAPILoader, 
    public translate: TranslateService
  ) {
    this.router.events.subscribe(data => {
      const id = route.snapshot.paramMap.get('id');
      this.compId = id;
    });

  }

  loadLatLng() {
    this.center = { lat: this.lat, lng: this.lng };
  }


  ngOnInit() {
    this.getCompany();

    //   this.mapToggle = true;
    // this.dataService.curProjects.subscribe(items => {
    //   this.items = items;
    // });
    this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
    this.compositeDesign = this.dataService.wichDesign().compositeDesign;
    this.unika = this.dataService.wichDesign().unika;

    // switch (window.location.host) {
    //   case 'getkey1.online':
    //     this.compTitle = 'Get Key 1';
    //     break;
    //   case 's-katorza.com':
    //     this.compTitle = 'S. Katorza';
    //     break;
    //   case 'spirical.net':
    //     this.compTitle = 'Spirikal';
    //     break;
    //   default:
    // }
    this.compTitle = this.dataService.hoisUrlGetTitle();
    if (!this.items) {
      // this.mapToggleMoreThan0 = new Subject();
      this.getProjects();
    }
    this.pageTitle = this.titleService.getTitle();
    this.dataService.getSpecComp(this.compId).subscribe(comp => {
      this.lat = +comp[0].lat;
      this.lng = +comp[0].lng;
      this.zoom = +comp[0].zoom;
      if (comp[0].googleMapStyles) {
        this.styles = JSON.parse(comp[0].googleMapStyles);
        console.log(this.styles, 'this.styles')
      }
      if (comp[0].markerImage) {
        this.marker_icon = comp[0].markerImage;
      }
    });

    if (this.pageTitle) {
      this.titleService.setTitle(this.pageTitle + " - מפה ");
    } else {
      this.dataService.currentComp.subscribe(comp => {
        this.pageTitle = 'spirikal ' + ' - ' + comp[0].name;
        this.titleService.setTitle(this.pageTitle + " - מפה ");
        this.lat = +comp[0].lat;
        this.lng = +comp[0].lng;
        this.zoom = +comp[0].zoom;
        if (comp[0].googleMapStyles) {
          this.styles = JSON.parse(comp[0].googleMapStyles);
          console.log(this.styles, 'this.styles 2')
        }
      });
    }
    let segment;
    if (this.route.snapshot.firstChild) {
      segment = this.route.snapshot.firstChild.url;
    } else {
      segment = this.route.snapshot.url;
    }
    this.ifCompositeDesign(segment);
    if (window.innerWidth < 768) {
      this.mapWidth = window.innerWidth.toString();
      this.mapHeight = window.innerHeight.toString(); // Adjust the height accordingly
    }
  }

  showVisualMapF() {
    console.log('test');
    this.showVisualMap = true;
    if (this.visualMapChildComponent) {
      this.visualMapChildComponent.showStatisticInfo();
    }
  }

  closeWindow() {
    this.infoWindow.close();
    //  this.infoWindow = null;
    this.showWindow = false;
  }

  ifCompositeDesign(segment) {
    for (let i = 0; segment.length > i; i++) {
      if (segment[i].path === 'n') {
        this.compositeDesign = true;
      } else if (segment[i].path === 'u') {
        this.compositeDesign = true;
        this.unika = true;
      }
    }
  }

  openPopUp(marker, item, infoWindow) {
    if (this.infoWindow) {
      if (this.infoWindow !== infoWindow) {
        this.infoWindow.close();
      }
    }
    this.itemToEdit = item;
    this.marker_item1 = item;
    this.dataService.getItemsByProjId(item.id).subscribe(buildList => {
      const buildings = [];
      this.buildings = [];
      console.log(buildList);
      if (buildList.length > 0) {
        // let statusCounter = this.getFlats(buildList);
        this.buildings = buildList;
        console.log(this.buildings);
      }
      this.showWindow = true;
      // this.infoWindow = infoWindow;
      this.infoWindow.open(marker);
    })

  }

  onResize(event) {

    this.mapWidth = event.target.innerWidth.toString();
    this.mapHeight = event.target.innerHeight.toString()
  }

  getProjects() {
    setTimeout(() => {
      this.dataService.getItemsByCompId(this.compId).subscribe(items => {
        // console.log(items, 'items in getProjects');
        // this.items = items;
        this.allProjects = items;

        items.forEach(item => {
          const lat: number = parseFloat(item.lat.toString());
          const lng: number = parseFloat(item.lng.toString());
          let marker;
          if (item.markerImage) {
            this.marker_icon = item.markerImage
          }
          const options: google.maps.MarkerOptions = {
            position: { lat: lat, lng: lng },
            icon: this.marker_icon,
            // icon_background_color: result.icon_background_color,
            // icon_mask_base_uri: result.icon_mask_base_uri,
            // geometry: result.geometry,
            // label: result.icon,
            animation: google.maps.Animation.DROP,
            title: item.name
          };
          item['options'] = options;
          this.marker_icon = "";
        });
        this.items = items;
        // console.log(this.items, 'new items')
      });
    }, 500);
  }

  // showMap() {
  //   this.mapToggle = !this.mapToggle;
  // }

  OnChanges(changes: SimpleChange) {

  }
  navigatToMainPage() {
    this.dataService.saveRemoveMenu('false');

    this.router.navigate([this.urlSwitcher + this.compId]);
    // if (this.compositeDesign && !this.unika) {
    //   this.router.navigate(['/company/n/' + this.compId]);
    // }  else if(this.unika) {
    //   this.router.navigate(['/company/u/' + this.compId]);
    // } 
  }
  udateProjectList(projIdArray) {
    let projectsToShow: any = [];
    projIdArray.forEach(projId => {
      projectsToShow.push(this.allProjects.filter(proj => proj.id === projId)[0]);
    })
    if (projIdArray.length > 0) {
      this.items = projectsToShow;
    } else {
      this.items = this.allProjects;
    }
    this.closeWindow();
  }
  showSearchResultsF($event) { }

  getCompany() {
    if (this.route.snapshot.url[0].path != 'admin') {
      this.dataService.getSpecComp(this.route.snapshot.paramMap.get("id")).subscribe(company => {
        console.log('initialMap', company)
        this.company = company[0];
        this.dataService.saveCurCompany(company);
        if (company.length !== 0) {
          if (company[0].lng != undefined && company[0].lng != 0) {
            this.lng = +company[0].lng
          }
          if (company[0].lat != undefined && company[0].lat != 0) {
            this.lat = +company[0].lat
          }
          if (company[0].zoom != undefined && company[0].zoom != '') {
            this.zoom = +company[0].zoom
          }
          if (company[0].googleMapStyles) {
            this.styles = JSON.parse(company[0].googleMapStyles);
            console.log(this.styles, 'this.styles 3')
          }
          if (company[0].markerImage) {
            this.marker_icon = company[0].markerImage
          }

          this.loadLatLng();
        }
      })
    }
  }

  clickedMarker(item) {
    console.log("test");
    // this.itemContent = true;
    // this.itemToview = item;
    // this.router.navigate(['/company/' + this.route.snapshot.params.id + '/' + item.uid + '/test']);
    this.router.navigate(['/company/' + this.route.snapshot.params.id + '/' + item.uid]);
    // this.dataService.openProjectClickOnMarker(item);
  }
  goToBuilding(buildingUid, project) {
    this.dataService.saveRemoveMenu('false');
    // this.router.navigate(['/company/n/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid]);
    // let uri = ['/company/n/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid];
    // this.router.navigate([uri[0]]);
    const link = '/company/u/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid
    window.open(link, '_blank')
  }

  goToPproject(project) {
    this.dataService.saveRemoveMenu('false');
    // this.router.navigate(['/company/n/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid]);
    // let uri = ['/company/n/' + this.route.snapshot.params.id + '/' + project.uid + '/building/' + buildingUid];
    // this.router.navigate([uri[0]]);
    const link = '/company/u/' + this.route.snapshot.params.id + '/' + project.uid
    window.open(link, '_blank')
  }

  testHover(item) {
    this.itemToEdit = item;
  }

  closeMap() {
    this.mapToggle = false;
  }
}
